import * as DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export class SafeHtmlUtils {

  /**
   * Sanitize le html avant de la passer dans BypassSecurityTrustHtml
   * @param html le html à nettoyer
   * @param sanitizer le sanitizer à utiliser
   * @param isWholeDocument indique si le html est un document entier
   * @returns le html nettoyé
   */
  public static sanitizeHtmlAndBypass(html: string | null | undefined, sanitizer: DomSanitizer, isWholeDocument: boolean = false): SafeHtml {
    if (!html) return sanitizer.bypassSecurityTrustHtml('');

    const cleanHtml = this.sanitizeHtmlString(html, isWholeDocument);
    return sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }

  /**
   * Nettoie le html
   * @param html le html à nettoyer
   * @param isWholeDocument indique si le html est un document entier
   * @returns le html nettoyé
   */
  public static sanitizeHtmlString(html: string | null | undefined, isWholeDocument: boolean = false): string {
    if (!html) return '';

    const cleanHtml = DOMPurify.sanitize(html, {
      FORBID_TAGS: ['script'],
      FORBID_ATTR: ['onerror', 'onload', 'onmouseover'],
      WHOLE_DOCUMENT: isWholeDocument
    });

    return cleanHtml as string;
  }

  /**
   * Escape les caracteres spéciaux du html
   * @param text le text à nettoyer
   * @returns le text nettoyé
   */
  public static escapeHtml(text: string | null | undefined): string {
    if (!text) return '';
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /**
   * Nettoie le svg avant de le passer dans BypassSecurityTrustHtml
   * @param svg le svg à nettoyer
   * @param sanitizer le sanitizer à utiliser
   * @returns le svg nettoyé
   */
  public static sanitizeSvgAndBypass(svg: string | null | undefined, sanitizer: DomSanitizer): SafeHtml {
    if (!svg) return sanitizer.bypassSecurityTrustHtml('');

    const cleanSvg = DOMPurify.sanitize(svg, {
      USE_PROFILES: { svg: true },
      FORBID_TAGS: ['script'],
      FORBID_ATTR: ['onerror', 'onload', 'onmouseover']
    });

    return sanitizer.bypassSecurityTrustHtml(cleanSvg);
  }
}
